import { useState, useEffect } from "react";
import Store from "../../Stores/Store";
import style from "./BalanceWIndow.module.scss";
import Heading from "../Typography/Heading/Heading";
import Text from "../Typography/Text/Text";
import UpBalance from "./UpBalance/UpBalance";
import getBalance from "../../API/getBalance";
import toMainImg from "../../Static/images/toMainImg.svg";
import { ReactComponent as BalanceImage } from "../../Static/images/balance.svg";
import { closeIframeMessage } from "../../Utils/iframeMessenger";
import Button from "../Button/Button";
import { canPay } from "../../Utils/Utils";

const BalanceWindow = ({ setBalanceWindowActive }) => {
  const [modalUpBalanceActive, setModalUpBalanceActive] = useState(false);
  const [balanceInfo, setBalanceInfo] = useState(null);
  const [debt, setDebt] = useState("");

  useEffect(() => {
    async function init() {
      calculateDebt();
    }
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function calculateDebt() {
    let balance = null;
    const data = await getBalanceInfo();
    setBalanceInfo(data);
    if (data !== "error") {
      //суммируем amount > 0 (задолженность) по всем аккаунтам и сервисам
      let balance = data.accounts.reduce(
        (accumulator, account) => accumulator + debtCheck(account),
        0
      );
      if (balance > 0) {
        //Если баланс > 0 (задолженность) выводим задолженность
        setDebt(Number("-" + balance.toFixed(2)));
      } else {
        //Если баланс < 0 (переплата) выводим баланс
        //суммируем amount по всем аккаунтам и сервисам
        balance = data.accounts.reduce(
          (accumulator, account) =>
            accumulator +
            account.services.reduce(
              (accumulator, servicesItem) => accumulator + servicesItem.amount,
              0
            ),
          0
        );
        setDebt(Number(Math.abs(balance).toFixed(2)));
      }
    } else {
      setDebt(balance);
    }
  }

  function debtCheck(account) {
    const debt = account.services.reduce((accumulator, servicesItem) => {
      if (servicesItem.amount > 0) {
        return accumulator + servicesItem.amount + servicesItem.penaltie;
      } else {
        return accumulator;
      }
    }, 0);
    if (debt > 0) {
      return debt;
    } else {
      return 0;
    }
  }

  async function getBalanceInfo() {
    let data;
    if (Store.payment.accounts.id_unified_account) {
      data = await getBalance(Store.payment.accounts.id_unified_account);
    } else {
      data = await getBalance(Store.payment.accounts.accounts[0].id_PA);
    }
    let tempBalance = data;
    if (data !== "error") {
      //добавляем поле totalAccountNegativeBalance (сумма всех amount > 0 по сервисам) в аккаунты
      //добавляем поле totalAccountPositiveBalance (сумма всех amount < 0 по сервисам) в аккаунты
      tempBalance.accounts.forEach((account) => {
        account.totalAccountNegativeBalance = Number(
          account.services
            .reduce((accumulator, service) => {
              if (service.amount > 0) {
                return accumulator + service.amount + service.penaltie;
              } else {
                return accumulator;
              }
            }, 0)
            .toFixed(2)
        );
        account.totalAccountPositiveBalance = Number(
          account.services
            .reduce((accumulator, service) => {
              if (service.amount < 0) {
                return accumulator + service.amount;
              } else {
                return accumulator;
              }
            }, 0)
            .toFixed(2)
        );
      });
      //считаем какую долю составляет service.amount от totalAccountNegativeBalance и добавляем поле partOfAccountNegativeBalance в сервисы
      //считаем какую долю составляет service.amount от totalAccountPositiveBalance и добавляем поле partOfAccountPositiveBalance в сервисы
      tempBalance.accounts.forEach((account) =>
        account.services.forEach((service) => {
          if (account.totalAccountNegativeBalance > 0) {
            service.partOfAccountNegativeBalance = Number(
              (
                (service.amount + service.penaltie) /
                account.totalAccountNegativeBalance
              ).toFixed(3)
            );
          } else {
            service.partOfAccountNegativeBalance = 0;
          }
          if (account.totalAccountPositiveBalance < 0) {
            service.partOfAccountPositiveBalance = Number(
              (service.amount / account.totalAccountPositiveBalance).toFixed(3)
            );
          } else {
            service.partOfAccountPositiveBalance = 0;
          }
        })
      );
      //суммируем все account.amount > 0 (задолженности), добавляем поле totalNegativeBalance
      tempBalance.totalNegativeBalance = Number(
        tempBalance.accounts
          .reduce((accumulator, account) => {
            if (account.totalAccountNegativeBalance) {
              return accumulator + account.totalAccountNegativeBalance;
            } else {
              return accumulator;
            }
          }, 0)
          .toFixed(2)
      );
      //суммируем все account.amount < 0 (переплаты), добавляем поле totalPositiveBalance
      tempBalance.totalPositiveBalance = Number(
        tempBalance.accounts
          .reduce((accumulator, account) => {
            if (account.totalAccountPositiveBalance) {
              return accumulator + account.totalAccountPositiveBalance;
            } else {
              return accumulator;
            }
          }, 0)
          .toFixed(2)
      );
    }
    return tempBalance;
  }

  function upBalance() {
    setModalUpBalanceActive(true);
  }

  function clickBack() {
    closeIframeMessage();
  }

  function renderDescription() {
    let description = "";
    if (debt === null) {
      description = "";
    } else {
      if (debt > 0) {
        description = "переплата";
      } else if (debt === 0) {
        description = "";
      } else if (debt < 0) {
        description = "задолженность";
      }
    }
    return description;
  }

  let core_device0;
  if (Store.payment.accountInfo.core_devices) {
    core_device0 = Store.payment.accountInfo.core_devices[0];
  } else {
    core_device0 = null;
  }

  return (
    <>
      <div className={style.balanceWindow}>
        <div
          className={style.balanceWindow__wrap}
          //onClick={(e) => e.stopPropagation()}
        >
          <div className={style.balanceWindow__wrap__back}>
            <div className={style.toMain} onClick={() => clickBack()}>
              <img src={toMainImg} alt="" />
              <Text size="medium">Главная</Text>
            </div>
            <div className={style.devider}>/</div>
            <div
              className={style.back}
              onClick={() => setBalanceWindowActive(false)}
            >
              <Text size="medium">Назад</Text>
            </div>
          </div>
          <div className={style.balanceWindow__wrap__title}>
            <Heading level="h3">
              {balanceInfo?.unified_number
                ? `ЕЛС № ${balanceInfo.unified_number}`
                : `ЛС № ${Store.payment.accountInfo.number}`}
            </Heading>
          </div>
          <div className={style.balanceWindow__wrap__content}>
            <div className={style.balanceWindow__wrap__content__address}>
              {core_device0 !== null && (
                <Text size="medium">
                  {core_device0.type_locality} {core_device0.locality}{" "}
                  {core_device0.type_street} {core_device0.street}{" "}
                  {core_device0.type_house} {core_device0.house}{" "}
                  {core_device0.type_building} {core_device0.building}{" "}
                  {core_device0.condos_number && "кв."}{" "}
                  {core_device0.condos_number}
                </Text>
              )}
            </div>
            <div
              className={
                debt !== null && debt >= 0
                  ? `${style.balanceWindow__wrap__content__balance}`
                  : `${style.balanceWindow__wrap__content__balance} ${style.debt}`
              }
            >
              <div
                className={style.balanceWindow__wrap__content__balance__text}
              >
                <BalanceImage />
                <div className={style.balance}>
                  <Heading level="h5">
                    {debt !== null
                      ? "Текущий баланс"
                      : "Ошибка сервера. Баланс не найден."}
                  </Heading>
                  <div className={style.description}>
                    <Text size="headerText">{renderDescription()}</Text>
                  </div>
                </div>
              </div>
              {debt !== null && (
                <div
                  className={style.balanceWindow__wrap__content__balance__value}
                >
                  <Heading level="h4">{debt} ₽</Heading>
                </div>
              )}
            </div>
            <div className={style.balanceWindow__wrap__content__button}>
              <Button
                disabled={debt === null || !balanceInfo || !canPay()}
                clickHandler={upBalance}
              >
                Пополнить
              </Button>
            </div>
            {!canPay() && (
              <div className={style.descriptionWater}>
                <Text size="small">
                  Для оплаты воды необходимо использовать единый лицевой счет
                </Text>
              </div>
            )}
          </div>
        </div>
      </div>
      {modalUpBalanceActive && (
        <UpBalance
          setModalUpBalanceActive={setModalUpBalanceActive}
          balanceInfo={balanceInfo}
          debt={debt}
        />
      )}
    </>
  );
};
export default BalanceWindow;
